import React, { Component } from "react";
import Data from "../config/data";
import ScrollView from "./ScrollView";
import Content from "./Content";

export default class PrivacyPage extends Component {

    render() {
        const data = Data.privacyAgreement;
        return (
            <ScrollView>
                <Content data={data} />
            </ScrollView>
        );
    }

}


// WEBPACK FOOTER //
// ./src/component/privacypage.js